import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconGeoLayerM(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5769 4.15646C12.2206 3.94785 11.7794 3.94785 11.4231 4.15646L4.56454 8.17245C3.81089 8.61374 3.81205 9.70323 4.56664 10.1429L11.4252 14.1393C11.7804 14.3463 12.2196 14.3463 12.5748 14.1393L19.4334 10.1429C20.188 9.70323 20.1891 8.61374 19.4355 8.17245L12.5769 4.15646ZM11.4231 5.47886C11.7794 5.27025 12.2206 5.27025 12.5769 5.47886L18.8586 9.15707L12.5748 12.8186C12.2196 13.0256 11.7804 13.0256 11.4252 12.8186L5.14141 9.15707L11.4231 5.47886ZM4.09188 11.6116L11.4403 15.7451C11.7878 15.9406 12.2122 15.9406 12.5597 15.7451L19.9081 11.6116C20.1215 12.1117 19.9631 12.7407 19.4334 13.0493L12.5748 17.0458C12.2196 17.2527 11.7804 17.2527 11.4252 17.0458L4.56664 13.0493C4.03687 12.7407 3.87846 12.1117 4.09188 11.6116ZM4.09188 14.4106L11.4403 18.5441C11.7878 18.7396 12.2122 18.7396 12.5597 18.5441L19.9081 14.4106C20.1215 14.9107 19.9631 15.5397 19.4334 15.8483L12.5748 19.8448C12.2196 20.0517 11.7804 20.0517 11.4252 19.8448L4.56664 15.8483C4.03687 15.5397 3.87846 14.9107 4.09188 14.4106Z"
      />
    </svg>
  )
}
export const IconGeoLayer = createIcon({
  l: IconGeoLayerM,
  m: IconGeoLayerM,
  s: IconGeoLayerM,
  xs: IconGeoLayerM,
  name: 'IconGeoLayer',
})
